module.exports = {"520303001":"上海路街道","520303002":"洗马路街道","520303003":"大连路街道","520303004":"高桥街道","520303005":"董公寺街道","520303006":"高坪街道","520303102":"团泽镇","520303104":"板桥镇","520303105":"泗渡镇","520303106":"沙湾镇","520303107":"山盆镇","520303108":"芝麻镇","520303109":"松林镇","520303110":"毛石镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520303.json
// module id = 2276
// module chunks = 0